<style lang="scss" scoped>
.card {
  width: 210px;
  height: 235px;
  background: #fff;
  padding: 15px;
  box-sizing: border-box;
  text-align: center;
  > img {
    border-radius: 50%;
    width: 100px;
    border: 1px solid #bdc7db;
  }
}
.name {
  border-bottom: 1px solid #bdc7db;
  padding: 8px 0 15px;
}
.aside {
  color: #fff;
  height: 100%;
  .info {
    padding: 70px 0 40px;
    text-align: center;
    .logo {
      border-radius: 50%;
      width: 70px;
      margin-bottom: 10px;
    }
    .name {
      font-size: 16px;
    }
  }
}
.weixin {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 50%;
  border: 1px solid #bdc7db;
  margin: 0 auto;
  .iconfont {
    font-size: 75px;
    color: #bdc7db;
  }
}
</style>
<template>
  <el-container style="height: 100vh;">
    <el-aside width="256px">
      <asides></asides>
    </el-aside>
    <el-container>
      <el-header height="90px" style="border-bottom:1px solid #979797;">
        <headers></headers>
      </el-header>
      <el-main style="background: #f9f9f9;" class="pt30">
        <div class="card fl ml20" v-for="item in list" :key="item.id">
          <img :src="item.headImg" alt class="logo" />
          <div class="name">{{item.nickName}}</div>
          <router-link :to="{path:`/third/${item.id}/home`}">
            <el-button class="mt20" size="small" type="primary">进入管理</el-button>
          </router-link>
        </div>
        <div class="card fl ml20" v-if="showBtn">
          <div class="weixin">
            <i class="iconfont">&#xe679;</i>
          </div>
          <div class="name">接入公众号</div>
          <el-button class="mt20" size="small" type="success" @click="shouquan">授权接入</el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import headers from '@/components/headers';
import asides from '@/components/asides2';
export default {
  components: {
    headers,
    asides,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  data() {
    return {
      list: [],
      showBtn: true,
    };
  },
  async mounted() {
    if (this.$route.query.auth_code) {
      let res = await this.$http.post(`/api/official-account/oauth/callback`, {
        authCode: this.$route.query.auth_code,
        expiresIn: this.$route.query.expires_in,
      });
      if (res) {
        this.$message.success('授权成功');
        this.$router.push(this.$route.path);
      }
    }
    let res = await this.$http.get('/api/official-accounts');
    this.list = res.list;

    // this.$http.get(`/api/official-account/oauth`).then(res => {
    //   console.log(res);
    //   this.showBtn = res;
    // });
  },
  methods: {
    async shouquan() {
      let res = await this.$http.get(`/api/official-account/oauth`);
      window.location.href = res.oAuthUrl;
    },
  },
};
</script>
